module.exports = __webpack_public_path__ + "static/studio-lounge-fa50780d1db535885dc672b63280aeba.jpg";